<template>
    <modal v-if="showConfirm" @close="$emit('cancel')">
        <h2 slot="header">Email Report</h2>
        <body slot="body">
            <p class="error-modal-text" v-if="messageProp !== ''">{{ messageProp }}</p>
            <p>Where do you want to send your report too?</p>
            <label for="email">Email</label>
            <input id="email" type="email" class="form-control" name="email" placeholder="Email" required
            v-model="email">
        </body>
        <div slot="footer">
            <button
                class="modal-default-button btn btn-default margin-left-10"
                type="button"
                @click="$emit('cancel')"
            >
                Cancel
            </button>
            <button
                class="modal-default-button btn btn-danger"
                type="button"
                @click="$emit('ok', email)"
                :disabled="email === ''"
            >
                OK
            </button>
        </div>
    </modal>

</template>

<script>
  import Modal from '../Modal.vue'

  export default {
    data() {
        return {
            email: this.emailProp || '',
        }
    },
    mounted() {
    },
    props: ['showConfirm', 'confirmMessage', 'emailProp', 'messageProp'],
    components: {
      Modal
    },
     events: {
         ok() {
           this.showConfirm = false;
         },
        cancel() {
            this.showConfirm = false;
         }
    },

  }
</script>
